import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/introduce',
    name: 'Introduce',
    component: () => import( /* webpackChunkName: "introduce" */ '../views/Introduce.vue')
  },
  {
    path: '/school',
    name: 'School',
    component: () => import( /* webpackChunkName: "school" */ '../views/School.vue')
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import( /* webpackChunkName: "cooperation" */ '../views/Cooperation.vue')
  },
  {
    path: '/document',
    name: 'Document',
    component: () => import( /* webpackChunkName: "document" */ '../views/Document.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import( /* webpackChunkName: "news" */ '../views/News.vue')
  },
  {
    path: '/face2pay',
    name: 'Face2Pay',
    component: () => import( /* webpackChunkName: "face2pay" */ '../views/Face2Pay.vue')
  },
  {
    path: '/face2pay-corp',
    name: 'Face2PayCorp',
    component: () => import( /* webpackChunkName: "face2pay" */ '../views/Face2Pay1.vue')
  },
  {
    path: '/classWallet',
    name: 'ClassWallet',
    component: () => import( /* webpackChunkName: "face2pay" */ '../views/ClassWallet.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router